import { CnTable } from "@sto/cn-ui";

/**
 * 重写CnTable组件，处理带小数点的key无法映射对应的值的问题
 * @param props 
 * @returns 
 */
const CustomCnTable = (props) => {
  const { dataSource, columns } = props;

  const formattedColumns = columns?.map(item => {
    return {
      ...item,
      dataIndex: `${item.dataIndex}`.replace(/\./g, ''), // 处理点号
    };
  }) || [];

  const formattedDataSource = dataSource?.map(item => {
    const temp = {};
    Object.keys(item).forEach(key => {
      temp[key.replace(/\./g, '')] = item[key];
    });
    return temp;
  }) || [];

  return <CnTable 
    {...props} 
    dataSource={formattedDataSource} 
    columns={formattedColumns} 
    maxHeight="300px"
  />;
};

export default CustomCnTable;